import { render } from "./productContent.vue?vue&type=template&id=3388b7ad&scoped=true"
import script from "./productContent.vue?vue&type=script&lang=js"
export * from "./productContent.vue?vue&type=script&lang=js"

import "./productContent.vue?vue&type=style&index=0&id=3388b7ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388b7ad"]])

export default __exports__